import {useGlobalDialog} from "@iolabs/wip-dialog";
import {Button, useTheme,} from "@material-ui/core";
import React from "react";
import {Link, useHistory, useLocation} from "react-router-dom";
import useStyles from "./styles";
import {useRouteMatch} from "react-router";

interface IOffersMenuProps extends React.HTMLAttributes<HTMLElement> {
    basePath: string;
}

interface IOffersMenuButtonProps extends React.HTMLAttributes<HTMLElement> {
    link?: string;
}

const OffersMenuButton: React.FC<IOffersMenuButtonProps> = ({link, children}: IOffersMenuButtonProps) => {
    return (
        <Link to={`${link}`}>
            <Button color={"inherit"}>{children}</Button>
        </Link>
    );
}

const OffersMenu: React.FC<IOffersMenuProps> = ({basePath}: IOffersMenuProps) => {

    const classes = useStyles();


    return (
        <>
            <div className={classes.menu}>
                <OffersMenuButton link={`${basePath}/offers`}>Nabídky</OffersMenuButton>
                <OffersMenuButton link={`${basePath}/invoices`}>Faktury</OffersMenuButton>
                <OffersMenuButton link={`${basePath}/companies`}>Firmy</OffersMenuButton>
                {/*<OrdersMenuButton link={`${basePath}/currencies`}>Měny</OrdersMenuButton>*/}
                {/*<OrdersMenuButton link={`${basePath}/files`}>Soubory</OrdersMenuButton>*/}
                {/*<OrdersMenuButton link={`${basePath}/system-variables`}>Proměnné systému</OrdersMenuButton>*/}
            </div>
        </>
    );
};

export default OffersMenu;
